import { render, staticRenderFns } from "./SlideScroll.vue?vue&type=template&id=2ed88ef0&scoped=true&"
import script from "./SlideScroll.vue?vue&type=script&lang=js&"
export * from "./SlideScroll.vue?vue&type=script&lang=js&"
import style0 from "./SlideScroll.vue?vue&type=style&index=0&id=2ed88ef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed88ef0",
  null
  
)

export default component.exports